import ModuleMixin from "../ModuleMixin";
import SnapshotModule from "../../../Snapshot/SnapshotModule/SnapshotModule.vue";
import SnapshotIcon from "../../../Snapshot/SnapshotIcon/SnapshotIcon.vue";
import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "Organisationsbeschreibung",
  components: {
    SnapshotModule,
    SnapshotIcon,
  },
  mixins: [
    ModuleMixin,
  ],
  computed: {
    optionsFormstepDetailLocal() {
      const OPTIONS = cloneDeep(this.optionsFormstepDetail);
      OPTIONS.list = [
        {
          id: "antwort",
          htmlId: `${ this.htmlRegelNummer }_antwort`,
          type: "richtext",
          label: "_LBL_GR_ORGANISATIONSBESCHREIBUNG_TITEL_",
          required: true,
          view: "v-alt",
          editonly: true,
          max: this.modelParameter.max_antwort,
          startupFocus: true,
        },
      ];
      return OPTIONS;
    },

    labelHeader() {
      if (this.modelParameter.frage_text) {
        return this.modelParameter.frage_text;
      }
      return "_TXT_GR_ORGANISATIONSBESCHREIBUNG_HEADER_";
    },

    statusDiff() {
      if (!this.snapshotModule) {
        return;
      }
      return this.snapshotModule.antwort !== this.model.antwort;
    },
  },
  methods: {
    prepareModel() {
      this.model = cloneDeep(this.module.data) || {};
    },
  },
};
